import { useSuspenseQuery } from '@apollo/client';
import {
  type FetchLatestKnowledgeBaseForHomeQuery,
  type FetchLatestKnowledgeBaseForHomeQueryVariables,
  QUERY_FETCH_LATEST_KNOWLEDGE_BASE,
  type FetchLatestPodcastForHomeQuery,
  type FetchLatestPodcastForHomeQueryVariables,
  QUERY_FETCH_LATEST_PODCAST,
} from '@edwin-group/people-graphql';
import { useMemo } from 'react';
import { getAuthentication } from '@/hooks/useAuthentication';

export const useArticlesAndPodcastsSection = () => {
  const userDocumentId = getAuthentication()?.user?.documentId ?? '';

  const { data: knowledgeBaseData } = useSuspenseQuery<
    FetchLatestKnowledgeBaseForHomeQuery,
    FetchLatestKnowledgeBaseForHomeQueryVariables
  >(QUERY_FETCH_LATEST_KNOWLEDGE_BASE, {
    fetchPolicy: 'cache-first',
  });

  const { data: podcastData } = useSuspenseQuery<
    FetchLatestPodcastForHomeQuery,
    FetchLatestPodcastForHomeQueryVariables
  >(QUERY_FETCH_LATEST_PODCAST, {
    fetchPolicy: 'cache-first',
    variables: { userDocumentId },
  });

  const latestKnowledgeBase = useMemo(() => {
    return knowledgeBaseData?.knowledgeBases?.nodes?.[0] || null;
  }, [knowledgeBaseData]);

  const latestPodcast = useMemo(() => {
    return podcastData?.podcasts?.nodes?.[0] || null;
  }, [podcastData]);

  return {
    latestKnowledgeBase,
    latestPodcast,
  };
};
